module.exports = __webpack_public_path__ + "img/traction.d21be04d.svg";